export const UH_CONSENT_COOKIE = 'uh_consent';
export const UH_CONSENT_MAX_AGE_SECONDS = 400 * 24 * 60 * 60;

export type StoredConsentChoice = 'accept' | 'reject' | 'custom';

export type StoredConsentCategories = {
  stats: boolean;
  analytics: boolean;
  ads: boolean;
};

export type ConsentRecord = {
  v: 1;
  ts: number;
  store: string;
  choice: StoredConsentChoice;
  categories?: StoredConsentCategories;
};

export function serializeConsent(record: ConsentRecord): string {
  return JSON.stringify(record);
}

export function parseConsent(raw: string | null | undefined): ConsentRecord | null {
  if (!raw) return null;
  try {
    const value = JSON.parse(raw) as Partial<ConsentRecord>;
    if (value.v !== 1) return null;
    if (
      value.choice !== 'accept' &&
      value.choice !== 'reject' &&
      value.choice !== 'custom'
    ) {
      return null;
    }
    if (typeof value.ts !== 'number' || typeof value.store !== 'string') {
      return null;
    }
    if (value.choice === 'custom') {
      const categories = value.categories;
      if (
        !categories ||
        typeof categories.stats !== 'boolean' ||
        typeof categories.analytics !== 'boolean' ||
        typeof categories.ads !== 'boolean'
      ) {
        return null;
      }
      return {
        v: 1,
        ts: value.ts,
        store: value.store,
        choice: 'custom',
        categories: {
          stats: categories.stats,
          analytics: categories.analytics,
          ads: categories.ads,
        },
      };
    }
    return { v: 1, ts: value.ts, store: value.store, choice: value.choice };
  } catch {
    return null;
  }
}
